import { render, staticRenderFns } from "./AddClaim.vue?vue&type=template&id=29045008&scoped=true&"
import script from "./AddClaim.vue?vue&type=script&lang=js&"
export * from "./AddClaim.vue?vue&type=script&lang=js&"
import style0 from "./AddClaim.vue?vue&type=style&index=0&id=29045008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29045008",
  null
  
)

export default component.exports